import { Avatar, Box, Divider, Grid, Link, Typography } from '@mui/material';
import { IEquipmentPrevOrder, IPrescription } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ContactUsHeadphones, SupportIcon } from 'Images';

interface IContactUs {
  order: IPrescription;
}

export const ContactUs = ({ order }: IContactUs) => {
  const medicationsDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const dictionaryMedicine = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const isDesktop = useIsDesktop();

  return (
    <Grid
      container
      justifyContent={'start'}
      sx={{
        paddingTop: '21px',
        paddingBottom: '16px',
        paddingLeft: '42px',
        paddingRight: '17px',
      }}
      wrap={'nowrap'}
    >
      <Grid
        item
        sx={{
          marginRight: '12px',
        }}
      >
        <Avatar
          alt=''
          src={ContactUsHeadphones}
          sx={{
            width: '32px',
            height: '32px',
          }}
        />
      </Grid>
      <Grid item>
        {order.status !== 4 ? (
          <Box>
            <Typography variant='body3'>
              {`${medicationsDictionary.haveQuestionsOnPrescriptions} ${medicationsDictionary.willBeHappyToHelp} ${medicationsDictionary.manualSupplyPhone}`}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography
              sx={{
                fontSize: '18px',
                display: 'inline',
                lineHeight: '25px',
              }}
            >{`${dictionaryMedicine.superPharmSupport}`}</Typography>
            <Typography
              component='a'
              href={
                isDesktop
                  ? undefined
                  : `tel: ${dictionaryMedicine.superPharmPhone}`
              }
              sx={{
                fontSize: '18px',
                display: 'inline',
                lineHeight: '25px',
                fontWeight: 700,
              }}
            >{`  ${dictionaryMedicine.superPharmPhone}`}</Typography>
            <Divider
              aria-hidden='true'
              flexItem
              orientation='vertical'
              sx={{
                height: '19px',
                display: 'inline-flex',
                margin: '0 0 0 5px',
                position: 'relative',
                top: '3px',
                right: '-5px',
              }}
            />
            <Typography
              sx={{
                fontSize: '18px',
                display: 'inline',
                lineHeight: '25px',
                ml: 2,
              }}
            >
              {dictionaryMedicine.moreInfoSuperPharm}
              <Link
                sx={{ textDecoration: 'underline' }}
                href={dictionaryMedicine.moreInfoSuperPharmLinkUrl}
                target='_blank'
              >
                {dictionaryMedicine.moreInfoSuperPharmLinkTitle}
              </Link>
            </Typography>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};
